/** @format */

import {
	Chain,
	CriteoViewItemMetadata,
	HomrProduct3DImagery,
	HomrProductStatsSlider,
	IHomrBanner,
	IHomrRichContent,
	IHomrSpot,
	IHomrState,
	IScoreCardSkuResponse,
	KillSwitches,
	ProcessedNonBundleProduct,
	ProductSku,
	PromotionDetailsMapV1,
	PromotionDetailsMapV2
} from '@shared/data-access/interfaces';
import {
	AccordionModule,
	AffirmPayLaterModule,
	DSProductRecommendationsComponent,
	ExclusiveProductPanelComponent,
	GoogleAdManagerComponent,
	ProductRecommendationsComponent,
	ProgressSpinnerComponent,
	ProTipsComponent
} from '@shared/components';
import {
	AddToCartSectionComponent,
	AddToCartSuccessComponent,
	FulfillmentButtonSubtextComponent,
	InStorePickupButtonComponent,
	SameDayDeliveryButtonComponent,
	ShipToMeButtonComponent
} from '@pdp/add-to-cart/components';
import {
	AemArticlesComponent,
	AppSnackbarComponent,
	BackToSearchResultsComponent,
	BNPLComponent,
	BrandLinkComponent,
	BreadcrumbComponent,
	CarouselSkeletonLoaderComponent,
	FrequentlyBoughtTogetherComponent,
	GtgtContentComponent,
	HighlightsComponent,
	HomrRichContentComponent,
	HomrStatsSlidersComponent,
	HomrTextLinkComponent,
	HomrWireSpotComponent,
	NotifyMePanelComponent,
	PriceComponent,
	ProductDescriptionComponent,
	ProductImageCarouselComponent,
	ProductImageViewerComponent,
	ProductInfoSpecsComponent,
	ProductInStoreServicesComponent,
	PromotionComponent,
	ReadyForNextRoundAddOnsComponent,
	ReturnPolicyComponent,
	ShippingComponent,
	ShoppableImageComponent,
	Sketchfab3dImageryComponent,
	SnackbarComponent,
	StyliticsComponent,
	StyliticsJumplinkComponent,
	StyliticsShopTheSetComponent,
	SyndigoComponent,
	TechSpecsComponent,
	TextileLabelComponent,
	WarrantyButtonComponent
} from '@pdp/components';
import {
	afterNextRender,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	computed,
	DestroyRef,
	effect,
	inject,
	input,
	OnInit,
	PLATFORM_ID,
	Signal,
	signal,
	ViewChild,
	viewChild,
	ViewContainerRef
} from '@angular/core';
import {
	selectSelectedColorAttribute,
	selectShouldShowAlternativeInStockRecs
} from '@pdp/attributes/data-access';
import {
	BreakpointsService,
	ExclusiveContentService,
	HttpService,
	Logger,
	Store,
	UtilityService,
	WINDOW
} from '@shared/data-access/services';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
	ExclusiveProductAdComponent,
	ExclusiveProductInfoComponent,
	ExclusiveProductOverlayComponent,
	ExclusiveProductPromoMessageComponent
} from '@pdp/exclusive-products/components';
import {
	GoldMemberStatusModule,
	ScorecardPointsComponent,
	ScoreRewardComponent
} from '@scorecard/components';
import { HmfAlertBannerComponent, HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { HotOnSocialButtonComponent, ImagesCarouselComponent } from '@social-content/components';
import { of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import {
	exclusiveApeValue,
	exclusiveBrands,
	exclusiveCTATypes,
	footwearApparelAttrNames,
	partyAttributes,
	partyAttrText
} from './in-stock-default.constants';
import {
	selectBrandLink,
	selectIsBOPISLOnly,
	selectIsComingSoon,
	selectIsProductWarrantyEligible,
	selectKillswitch,
	selectNearbyAvailableStoreCount,
	selectProductCatalogRatingCount,
	selectProductCatalogRatingValue,
	selectProductHasColorWithStylitics,
	selectResolvedSku,
	selectResolvedSkuPartNumber,
	selectStyliticsWidgetShown,
	selectTextileLabelInfo,
	selectWarrantiesEnabled
} from '@pdp/data-access/state';
import { selectHomrGTGTContent } from '@state/data-access';
import {
	selectIsInStoreOnlyProduct,
	selectShouldShowOutOfStockRecs,
	setNearbyStoresButtonEnabledFlag
} from '@pdp/add-to-cart/data-access';

import { ActivatedRoute } from '@angular/router';
import { AttributesComponent } from '@pdp/attributes/components';
import { AuthenticationService } from '@shared/authentication/data-access';
import { BreakPointNew } from '@shared/data-access/enums';
import { CertonaService } from '@product-recommendations/data-access';
import { CompareSectionComponent } from './compare-section/compare-section.component';
import { CustomizeProductButtonComponent } from '@pdp/custom/components';
import { DynamicProductTemplate } from '@pdp/data-access/enums';
import { DynamicProductTemplateClass } from '../shared/dynamic-product-template-class.interface';
import { HomrBannerComponent } from '@shared/homr/components';
import { HomrContentService } from '@pdp/utils';
import { Store as NgRxStore } from '@ngrx/store';
import { PLA_PLACEHOLDER_HIDDEN_CLASS } from '@shared/data-access/constants';
import { ProductRecommendationsRailComponent } from '@product-recommendations/components';
import { ProductService } from '@shared/data-access/product';
import { QueryStringParamService } from '@pdp/data-access/services';
import { ReviewBVReviewsComponent } from '@product-reviews/components/review-bv-reviews';
import { ReviewHighlightContainerComponent } from '@product-reviews/components/review-highlight-container';
import { ReviewHighlyRatedFeaturesComponent } from '@product-reviews/components/review-highly-rated-features';
import { ReviewHighlyRatedFeaturesModalComponent } from '@product-reviews/components/review-highly-rated-features-modal';
import { ReviewMultimediaCountComponent } from '@product-reviews/components/review-multimedia-count';
import { ReviewQuestionsAndAnswersV2Component } from '@product-reviews/components/review-questions-and-answers-v2';
import { ReviewRatingSummaryStarsComponent } from '@product-reviews/components/review-rating-summary-stars';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { HomrInStoreServices } from '@shared/homr/data-access';

@Component({
	selector: 'pdp-templates-in-stock-default',
	templateUrl: './in-stock-default.component.html',
	styleUrl: './in-stock-default.component.scss',
	imports: [
		AccordionModule,
		AddToCartSectionComponent,
		AddToCartSuccessComponent,
		AemArticlesComponent,
		AppSnackbarComponent,
		AffirmPayLaterModule,
		AttributesComponent,
		BackToSearchResultsComponent,
		BNPLComponent,
		BrandLinkComponent,
		BreadcrumbComponent,
		CommonModule,
		CustomizeProductButtonComponent,
		ExclusiveProductAdComponent,
		ExclusiveProductInfoComponent,
		ExclusiveProductOverlayComponent,
		ExclusiveProductPanelComponent,
		ExclusiveProductPromoMessageComponent,
		FrequentlyBoughtTogetherComponent,
		FulfillmentButtonSubtextComponent,
		GoldMemberStatusModule,
		GoogleAdManagerComponent,
		GtgtContentComponent,
		HighlightsComponent,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		HomrBannerComponent,
		HomrTextLinkComponent,
		HomrStatsSlidersComponent,
		HomrWireSpotComponent,
		HomrRichContentComponent,
		HotOnSocialButtonComponent,
		ImagesCarouselComponent,
		InStorePickupButtonComponent,
		NotifyMePanelComponent,
		PriceComponent,
		ProductDescriptionComponent,
		ProductImageCarouselComponent,
		CarouselSkeletonLoaderComponent,
		ProductImageViewerComponent,
		ProductInfoSpecsComponent,
		ProductRecommendationsComponent,
		ProductRecommendationsRailComponent,
		ProductInStoreServicesComponent,
		ProgressSpinnerComponent,
		PromotionComponent,
		ProTipsComponent,
		ReadyForNextRoundAddOnsComponent,
		ReturnPolicyComponent,
		ReviewBVReviewsComponent,
		ReviewHighlightContainerComponent,
		ReviewHighlyRatedFeaturesComponent,
		ReviewHighlyRatedFeaturesModalComponent,
		ReviewMultimediaCountComponent,
		ReviewQuestionsAndAnswersV2Component,
		ReviewRatingSummaryStarsComponent,
		SameDayDeliveryButtonComponent,
		ScorecardPointsComponent,
		ScoreRewardComponent,
		ShippingComponent,
		ShipToMeButtonComponent,
		ShoppableImageComponent,
		SnackbarComponent,
		Sketchfab3dImageryComponent,
		StyliticsComponent,
		StyliticsJumplinkComponent,
		StyliticsShopTheSetComponent,
		SyndigoComponent,
		TechSpecsComponent,
		TextileLabelComponent,
		WarrantyButtonComponent,
		CompareSectionComponent,
		DSProductRecommendationsComponent
	],
	host: {
		'(window:isShoppableBVImageEnabled)': 'onShoppableBVImageEnabled()',
		'(window:readyForNextRoundAddOnsEnabled)': 'onReadyForNextRoundAddOnsEnabled()'
	}
})
export class InStockDefaultComponent
	implements
		DynamicProductTemplateClass<DynamicProductTemplate.IN_STOCK_DEFAULT>,
		OnInit,
		AfterViewInit
{
	//#region *** Dependency Injection ***
	private readonly document = inject(DOCUMENT);
	private readonly platformId = inject(PLATFORM_ID);
	private readonly window = inject(WINDOW) as Window;
	private readonly authService = inject(AuthenticationService);
	private readonly certonaService = inject(CertonaService);
	private readonly exclusiveContentService = inject(ExclusiveContentService);
	private readonly httpService = inject(HttpService);
	private readonly logger = inject(Logger);
	private readonly ngRxstore = inject(NgRxStore);
	private readonly productService = inject(ProductService);
	private readonly breakpointsService = inject(BreakpointsService);
	private readonly store = inject(Store);
	private readonly utilityService = inject(UtilityService);
	private readonly route = inject(ActivatedRoute);
	readonly chain = inject(Chain);
	private readonly changeDetectorRef = inject(ChangeDetectorRef);
	private readonly homrContentService = inject(HomrContentService);
	private readonly destroyRef = inject(DestroyRef);
	//#endregion

	//#region *** View Children ***
	readonly highlyRatedFeaturesModal: Signal<ReviewHighlyRatedFeaturesModalComponent> =
		viewChild.required('highlyRatedFeaturesModal');

	/**
	 * @description
	 * Reference to the view position where the above the fold content will be placed.
	 * For some unknown reason, using this errors with `Unexpected state: no hydration info available for a given TNode,
	 * which represents a view container.` if we try to use signal viewChild queries.
	 */
	@ViewChild('targetAboveTheFoldViewRef', { read: ViewContainerRef })
	targetAboveTheFoldViewRef: ViewContainerRef;
	//#endregion

	//#region *** Inputs ***
	/**
	 * @description
	 * Reference to the initial view position of the section before it is moved into this
	 * component's template
	 */
	readonly sourceAboveTheFoldViewRef = input<ViewContainerRef>();

	/**
	 * @description
	 * The product currently being displayed
	 */
	readonly product = input.required<ProcessedNonBundleProduct>();

	/**
	 * @description
	 * The kill switches
	 */
	readonly killSwitches = input<KillSwitches>();

	/**
	 * @description
	 * The promotions to be displayed
	 */
	readonly promotions = input<PromotionDetailsMapV1 | PromotionDetailsMapV2>();

	//#endregion

	//#region *** Feature Flags ***
	/**
	 * @description
	 * Flag to determine if Google PLA functionality is enabled
	 */
	readonly isPLAEnabled = this.ngRxstore.selectSignal(selectKillswitch('isPLAEnabled'));

	/**
	 * @description
	 * Determine if we should show in store services content
	 */
	readonly inStoreServicesEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('inStoreServicesEnabled')
	);

	readonly frequentlyBoughtTogetherKillSwitchEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('frequentlyBoughtTogetherEnabled')
	);

	readonly showSponsoredProducts = this.ngRxstore.selectSignal(
		selectKillswitch('showSponsoredProducts')
	);

	/** @description killswitch for sustainability icons */
	readonly sustainablityIconsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('sustainablityIconsEnabled')
	);

	/**  @description Determines whether to show the info summary on product description */
	readonly infoSummaryEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('infoSummaryEnabled')
	);

	/** @description Add Pre Order content; */
	readonly preOrderEnabled = this.ngRxstore.selectSignal(selectKillswitch('preOrderEnabled'));

	/** @description feature flag for breadcrumbs */
	readonly browseBreadcrumbsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('browseBreadcrumbsEnabled')
	);

	/** @description Determine if stylitics is enabled for environment */
	readonly styliticsEnabled = this.ngRxstore.selectSignal(selectKillswitch('styliticsEnabled'));

	/** @description Enable/Disable Stylitics Model Outfit Badge */
	readonly styliticsShopTheLookEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('styliticsShopTheLookEnabled')
	);

	/** @description Determine if stylitics mix and match is enabled for environment */
	readonly styliticsMnMEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('styliticsMnMEnabled')
	);
	readonly styliticsShopTheSetEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('styliticsShopTheSetEnabled')
	);

	/** @description Determine if Syndigo is enabled for environment */
	readonly syndigoEnabled = this.ngRxstore.selectSignal(selectKillswitch('syndigoEnabled'));

	/** @description Feature flag for AEM content. */
	readonly enableAEMContent = this.ngRxstore.selectSignal(selectKillswitch('enableAEMContent'));

	/**
	 * @description used for SDD fulfillment button
	 */
	readonly sameDayDeliveryEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('sameDayDeliveryEnabled')
	);

	/**
	 * @description determines whether or not to display EDD message on shipping button
	 */
	readonly skuEDDEnabled = this.ngRxstore.selectSignal(selectKillswitch('skuEDDEnabled'));

	/**
	 * @description Feature flag for whether to show the content zone on non-exclusive pdps
	 */
	readonly nonExclusiveContentZoneEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('nonExclusiveContentZoneEnabled')
	);

	/**
	 * @description used for nike exclusive products
	 */
	readonly isNikeConnectedEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isNikeConnectedEnabled')
	);

	/**
	 * @description used for gold exclusive products
	 */
	readonly isGoldExclusiveEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isGoldExclusiveEnabled')
	);

	/**
	 * @description feature flag for Sketchfab 3D imagery component
	 */
	readonly isSketchfab3dEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isSketchfab3dEnabled')
	);

	/**
	 * @description
	 * Feature flag for PDP ProTips.
	 */
	readonly isPDPProTipsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isPDPProTipsEnabled')
	);

	readonly enhancedContentEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('enhancedContentEnabled')
	);

	readonly isComparisonTableEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isComparisonTableEnabled')
	);

	readonly sizeSelectionPanelEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('sizeSelectionPanelEnabled')
	);

	/**
	 * @description
	 * Feature flag for survey tooltip on bottom/grid ad
	 */
	readonly enableTooltipSurvey = this.ngRxstore.selectSignal(
		selectKillswitch('enableTooltipSurvey')
	);
	readonly isRibbonGAMBannerEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isRibbonGAMBannerEnabled')
	);

	readonly newDataScienceRecommendationsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('newDataScienceRecommendationsEnabled')
	);
	readonly isPLADSCarouselEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isPLADSCarouselEnabled')
	);
	readonly pdpGoogleAdManagerEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('pdpGoogleAdManagerEnabled')
	);

	readonly alternativeInStockRecsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('alternativeInStockRecsEnabled')
	);
	/**
	 * @description
	 * Feature flag review widget.
	 */
	readonly reviewsOff = this.ngRxstore.selectSignal(selectKillswitch('reviewsOff'));
	/**
	 * @description
	 * Feature flag new reviews widget.
	 */
	readonly newReviews = this.ngRxstore.selectSignal(selectKillswitch('newReviews'));
	readonly useProductCatalogRatingData = this.ngRxstore.selectSignal(
		selectKillswitch('useProductCatalogRatingData')
	);
	readonly reviewsMVPRetest = this.ngRxstore.selectSignal(selectKillswitch('reviewsMVPRetest'));
	readonly dataScienceRecommendationsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('dataScienceRecommendationsEnabled')
	);
	readonly colorSelectionPanelEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('colorSelectionPanelEnabled')
	);
	readonly newDataScienceRecommendationsEnabledNoPer = this.ngRxstore.selectSignal(
		selectKillswitch('newDataScienceRecommendationsEnabledNoPer')
	);
	readonly dropdownAttributesEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('dropdownAttributesEnabled')
	);
	readonly useAboveTheFoldMobileContainer = this.ngRxstore.selectSignal(
		selectKillswitch('useAboveTheFoldMobileContainer')
	);
	readonly isLoadingStateRecsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isLoadingStateRecsEnabled')
	);
	readonly isUtahLawLabelAccordionEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isUtahLawLabelAccordionEnabled')
	);
	readonly isSSRPLAEnabled = this.ngRxstore.selectSignal(selectKillswitch('isSSRPLAEnabled'));
	readonly isReviewImgPlacementEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isReviewImgPlacementEnabled')
	);
	readonly rightHandRailYouMayAlsoLikeEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('rightHandRailYouMayAlsoLikeEnabled')
	);
	readonly rightHandRailCustomersAlsoBoughtEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('rightHandRailCustomersAlsoBoughtEnabled')
	);

	/**
	 * @description
	 * Feature flag to show the top 3 highly rated features
	 */
	readonly isHighlyRatedReviewsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isHighlyRatedReviewsEnabled')
	);

	readonly isBrandLinkEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isBrandLinkEnabled')
	);
	readonly isJumpLinkEnabled = this.ngRxstore.selectSignal(selectKillswitch('isJumpLinkEnabled'));

	/** @description Determine if we should show Score Reward Message */
	readonly isScorerewardsMessageEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isScorerewardsMessageEnabled')
	);
	/**
	 * @description
	 * Feature flags for Social Images features
	 */
	readonly isSocialImagesEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isSocialImagesEnabled')
	);

	/**
	 * @description
	 * flag to toggle BOPIS text
	 */
	readonly nearbyStoresButtonEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('nearbyStoresButtonEnabled')
	);

	readonly isPLAPlaceholderEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isPLAPlaceholderEnabled')
	);

	readonly isSocialImageAboveReviewsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isSocialImageAboveReviewsEnabled')
	);
	readonly isSocialImageBelowProductInfoEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isSocialImageBelowProductInfoEnabled')
	);

	readonly isShoppableBVImageEnabledOverride = signal<boolean | null>(null);
	private readonly _isShoppableBVImageEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('isShoppableBVImageEnabled')
	);
	readonly isShoppableBVImageEnabled = computed(() => {
		if (this.isShoppableBVImageEnabledOverride() !== null) {
			return this.isShoppableBVImageEnabledOverride();
		}
		return this._isShoppableBVImageEnabled();
	});

	/* Event from adobe target for BV Shoppable Static Images*/
	public onShoppableBVImageEnabled() {
		this.isShoppableBVImageEnabledOverride.set(true);
	}

	readonly readyForNextRoundAddOnsEnabledOverride = signal<boolean | null>(null);
	private readonly _readyForNextRoundAddOnsEnabled = this.ngRxstore.selectSignal(
		selectKillswitch('readyForNextRoundAddOnsEnabled')
	);
	readonly readyForNextRoundAddOnsEnabled = computed(() => {
		if (this.readyForNextRoundAddOnsEnabledOverride() !== null) {
			return this.readyForNextRoundAddOnsEnabledOverride();
		}
		return this._readyForNextRoundAddOnsEnabled();
	});

	/* Event so that adobe target can set this flag after page load */
	public onReadyForNextRoundAddOnsEnabled() {
		this.readyForNextRoundAddOnsEnabledOverride.set(true);
	}

	//#endregion

	/**
	 * @description
	 * If it's mobile viewport
	 * NOTE: Please don't initialize this flag. The undefined value is used for loading
	 * mobile components in SSR and then hidden them in the browser using media queries
	 * when the viewport is for desktop
	 */
	readonly isMobile = signal<boolean | undefined>(undefined);
	readonly isDesktopExtraLarge = signal<boolean | undefined>(undefined);

	readonly scoreCardData = toSignal<IScoreCardSkuResponse[]>(
		this.store.selectDistinctKey('SCORECARD_DATA').pipe(filter((data) => data !== undefined))
	);

	readonly criteoViewItemMetadata = computed<CriteoViewItemMetadata>(() => {
		const product = this.product();
		return {
			item: product?.skus[0]?.partNumber,
			price: product?.skus[0]?.prices?.offerPrice?.toString(),
			availability: product?.skus[0]?.buyable,
			parentItem: product?.skus[0]?.parentPartNumber
		};
	});

	readonly stateSelectedColorAttribute = this.ngRxstore.selectSignal(
		selectSelectedColorAttribute
	);
	readonly selectedColorAttribute = computed(() => {
		const selectedColorFromState = this.stateSelectedColorAttribute()?.value;
		if (selectedColorFromState) {
			return selectedColorFromState.replace(/[/ -]/g, '_');
		}

		const defaultColor = this.productService.determineProductDefaultColor(this.product());
		if (defaultColor) {
			return defaultColor.replace(/[/ -]/g, '_');
		}
	});

	//#region *** Exclusive Product Logic ***
	readonly nikeLoginSuccess = signal(false);

	/**
	 * @description If product is exclusive, it will return the exclusive name. If not it will return an empty string.
	 */
	readonly exclusiveType = computed(() => {
		if (this.product().skus) {
			const exclusiveType = this.getRawExclusiveType(this.product().skus);

			// capitalizing first letter to match exclusive name of json file
			if (exclusiveType) {
				return exclusiveType.charAt(0).toUpperCase() + exclusiveType.slice(1);
			}
		}
		return '';
	});

	readonly isAuthenticated = signal(false);

	/**
	 * @description Sets Exclusive CTA type based on exclusive type and if user is signed in.
	 */
	readonly exclusiveCTAType = computed(() => {
		const exclusiveName = this.exclusiveType()?.toLowerCase();
		if (this.isAuthenticated()) {
			return exclusiveCTATypes[exclusiveName]?.loggedIn;
		} else {
			return exclusiveCTATypes[exclusiveName]?.notLoggedIn;
		}
	});

	/**
	 * @description
	 * Boolean representing if current user has logged in and unlocked the exclusive product type.
	 */
	readonly isAuthenticatedAndExclusiveUnlocked = signal(false);

	readonly isNikeApeExclusive = computed(() =>
		this.product().descriptiveAttributes?.some(
			(attribute) =>
				attribute &&
				attribute.identifier === '5632' &&
				`${attribute.value}`.toLowerCase() === 'nike ape exclusive'
		)
	);

	// brand/manufacturer for product
	readonly brand = computed(
		() =>
			this.product().descriptiveAttributes?.find(
				(attribute) => attribute && attribute.identifier === 'X_BRAND'
			)?.value as string
	);

	readonly shouldShowExclusiveContentAd = computed(
		() =>
			exclusiveBrands.includes(this.brand()) &&
			!this.isNikeApeExclusive() &&
			this.nonExclusiveContentZoneEnabled()
	);

	readonly showExclusive = computed(
		() =>
			!!this.exclusiveType() &&
			(this.exclusiveType() !== 'Gold' ||
				(this.exclusiveType() === 'Gold' && this.isGoldExclusiveEnabled()))
	);

	/**
	 * @description Used to check if Nike connected button should be displayed.
	 */
	readonly shouldNikeConnectedButtonBeDisplayed = computed(
		() =>
			this.isNikeConnectedEnabled() &&
			this.exclusiveType() === 'Nike' &&
			this.isAuthenticatedAndExclusiveUnlocked() === false
	);

	readonly shouldGoldExclusiveButtonBeDisplayed = computed(
		() =>
			this.isGoldExclusiveEnabled() &&
			this.exclusiveType() === 'Gold' &&
			this.isAuthenticatedAndExclusiveUnlocked() === false
	);
	//#endregion

	/**
	 * @description
	 * Signal that indicates if valid FBT recommendations are available
	 */
	readonly fbtRecommendationStatus = this.certonaService.getSchemeStatus('product3_rr');

	readonly compareDataStatus = this.certonaService.getSchemeStatus('product_rr');

	/**
	 * @description
	 * Signal that indicates if the product is coming soon
	 */
	protected readonly isComingSoon = this.ngRxstore.selectSignal(selectIsComingSoon);

	readonly skuIdQueryParam = signal<string | undefined>(undefined);

	/**
	 * @description
	 * Determines whether or not to show the in store only fulfillment scenario
	 * based of buyable attribute from the API
	 */
	readonly inStoreOnlyFulfillmentScenario = this.ngRxstore.selectSignal(
		selectIsInStoreOnlyProduct
	);

	readonly resolvedSkuPartNumber = this.ngRxstore.selectSignal(selectResolvedSkuPartNumber);

	readonly resolvedSku = this.ngRxstore.selectSignal(selectResolvedSku);

	readonly shouldShowOutOfStockRecs = this.ngRxstore.selectSignal(selectShouldShowOutOfStockRecs);
	readonly nearbyStoreCount = this.ngRxstore.selectSignal(selectNearbyAvailableStoreCount);
	readonly textileLabelInfo = this.ngRxstore.selectSignal(selectTextileLabelInfo);
	readonly shouldShowAlternativeInStockRecs = this.ngRxstore.selectSignal(
		selectShouldShowAlternativeInStockRecs
	);

	readonly isBOPISLOnly = this.ngRxstore.selectSignal(selectIsBOPISLOnly);

	readonly isProductWarrantyEligible = this.ngRxstore.selectSignal(
		selectIsProductWarrantyEligible
	);

	readonly brandLink = this.ngRxstore.selectSignal(selectBrandLink);

	readonly styliticsWidgetShown = this.ngRxstore.selectSignal(selectStyliticsWidgetShown);
	readonly productHasColorWithStylitics = this.ngRxstore.selectSignal(
		selectProductHasColorWithStylitics
	);

	/**
	 * @description Compares the Defining Attribute Name from the product and seeing if they are apparel or footwear related ones.
	 * @return true if the product has footwear or apparel related Attr. Names which are listed in the footwearApparelAttrNames attr. array
	 */
	readonly isApparelOrFootwear = computed(() => {
		if (this.product().definingAttributes && this.product().definingAttributes.length > 0) {
			return this.product().definingAttributes.every((attrName) =>
				footwearApparelAttrNames.some(
					(footwearApparelAttr) =>
						attrName.name.replace(/\s/g, '').toLowerCase() === footwearApparelAttr
				)
			);
		}
		return false;
	});

	readonly wasAboveTheFoldContentLoaded = signal(false);
	readonly warrantiesEnabled = this.ngRxstore.selectSignal(selectWarrantiesEnabled);

	/**
	 * @description
	 * replaces the isPlatformBrowser(this.platformId) function call
	 */
	readonly isPlatformBrowser = signal(false);

	/* Homr lazy content */
	readonly homrStatSliderLoaded = signal(false);
	readonly homrSliderData = signal<HomrProductStatsSlider[]>(undefined);
	readonly homrRichContent = signal<IHomrRichContent>(undefined);
	readonly homrTextLinkContent = signal<IHomrSpot[]>(undefined);
	readonly sketchfab3DData = signal<HomrProduct3DImagery[]>(undefined);
	readonly homrWireSpot = signal(false);
	readonly lazyHomrGTGTContent = this.ngRxstore.selectSignal(selectHomrGTGTContent);
	readonly lazyHomrBannerContent = signal<IHomrBanner>(undefined);
	readonly lazyHomrInStoreServicesContent = signal<HomrInStoreServices>(undefined);

	//#region *** PLA Logic ***
	readonly plaDataScienceRecommendationsErrored = signal(false);

	readonly plaPlaceholderClass = PLA_PLACEHOLDER_HIDDEN_CLASS;

	readonly isPLARequest = computed(() => {
		if (this.isPLAEnabled()) {
			if (this.isSSRPLAEnabled()) {
				return this.productService.isPLA(this.isPlatformBrowser());
			}
			if (this.isPlatformBrowser()) {
				return this.productService.setupPla(this.document.referrer, this.route);
			}
		}
		return false;
	});

	readonly shouldShowPLA = computed(() => {
		if (this.isSSRPLAEnabled() && !this.isPlatformBrowser() && this.isPLADSCarouselEnabled()) {
			return false; // homefield carousel does not support SSR yet
		}
		return this.isPLARequest() && !this.plaDataScienceRecommendationsErrored();
	});

	readonly isResonanceReady = toSignal(
		this.certonaService.resonanceReadyState.pipe(
			map((resonanceReady) => resonanceReady?.isPLAEnabled)
		)
	);

	readonly dataScienceRecommendationsLoaded = signal(false);

	/**
	 * @description encapsulates spinner logic to reduce clutter in the spinner's ngIf. If there are any dataScienceRecommendation flags enabled, we should use dataScienceRecommendationsLoaded to show/hide the spinner. Otherwise we should use isResonanceReady.
	 */
	readonly shouldShowSpinner = computed(() => {
		if (this.isLoadingStateRecsEnabled()) {
			return false;
		}

		const dsRecsEnabled = this.dataScienceRecommendationsEnabled();
		const newDSRecsEnabled = this.newDataScienceRecommendationsEnabled();
		const newDSRecsNoPerEnabled = this.newDataScienceRecommendationsEnabledNoPer();

		if (dsRecsEnabled || newDSRecsEnabled || newDSRecsNoPerEnabled) {
			return !this.dataScienceRecommendationsLoaded();
		}

		return !this.isResonanceReady();
	});
	//#endregion

	readonly sizeandFitSummary = computed(() =>
		(
			this.product().descriptiveAttributes?.find(
				(attribute) =>
					attribute &&
					attribute.identifier === '5426' &&
					attribute.name.toLowerCase() === 'size and fit summary'
			)?.value as string
		)?.split('|')
	);

	/** @description has return policy attribute to show return-policy-v2 component */
	readonly hasReturnPolicy = computed(() =>
		this.product().descriptiveAttributes?.some(
			(attribute) => attribute && attribute.identifier === '5749'
		)
	);

	readonly ratingCount = this.ngRxstore.selectSignal(selectProductCatalogRatingCount);
	readonly ratingValue = this.ngRxstore.selectSignal(selectProductCatalogRatingValue);

	readonly isHydrated = signal(false);

	readonly templateName = DynamicProductTemplate.IN_STOCK_DEFAULT as const;

	constructor() {
		this.isPlatformBrowser.set(isPlatformBrowser(this.platformId));

		if (this.isPlatformBrowser()) {
			afterNextRender(() => {
				this.isHydrated.set(true);
			});

			effect(() => {
				const breakpoint = this.breakpointsService.breakpoint();
				if (this.isHydrated()) {
					this.isMobile.set(breakpoint <= BreakPointNew.SMALL);
					this.isDesktopExtraLarge.set(breakpoint >= BreakPointNew.EXTRALARGE);
					this.changeDetectorRef.detectChanges();
				}
			});
		}
	}

	ngOnInit(): void {
		const queryString = this.httpService.getQueryString();

		if (QueryStringParamService.doesQueryStringHaveParameter(queryString, 'sku')) {
			// set the sku id passed from the param
			this.skuIdQueryParam.set(
				this.httpService.getParameterValuesFromQueryString(queryString, 'sku')
			);
		}

		this.ngRxstore.dispatch(
			setNearbyStoresButtonEnabledFlag({
				nearbyStoresButtonEnabled: this.nearbyStoresButtonEnabled()
			})
		);

		this.setupPlaPlatformBrowserContent();
	}

	private setupPlaPlatformBrowserContent(): void {
		// Check if current context is browser
		if (this.isPlatformBrowser()) {
			if (typeof this.route?.queryParams !== 'undefined') {
				this.utilityService.isTruthy(
					this.route.queryParams.subscribe((value) => {
						this.nikeLoginSuccess.set(value.CONNECTION_STATUS === 'SUCCESS');
						if (this.nikeLoginSuccess()) {
							// Removing CONNECTION_STATUS query param from history to avoid overlay reshowing when users click back
							history.replaceState(null, null, this.window.location.pathname);
							// Clear old party attributes, so we can retrieve the latest
							sessionStorage.removeItem('partyAttributes');
						}
					})
				);
			}

			this.store
				.selectDistinctKey('HOMR_DATA')
				.pipe(
					takeUntilDestroyed(this.destroyRef),
					filter((data) => data !== undefined)
				)
				.subscribe((data: IHomrState) => {
					if ('homrRichContent' in data) {
						if (data.homrRichContent.productStatsSlider) {
							this.homrSliderData.set(data.homrRichContent.productStatsSlider);
							this.homrStatSliderLoaded.set(true);
						} else if (
							this.homrContentService.shouldHomrRichContentBeDisplayed(
								data.homrRichContent
							)
						) {
							this.homrRichContent.set(data.homrRichContent);
						}
						const sketchfab3DContent = this.utilityService.findPropertyInObject(
							data.homrRichContent,
							'pdp3DImagery'
						);
						if (sketchfab3DContent && this.isSketchfab3dEnabled()) {
							this.sketchfab3DData.set(sketchfab3DContent);
						}
					}
					if ('homrContent' in data) {
						this.homrTextLinkContent.set(data.homrContent);
					}
					if ('homrBanner' in data) {
						this.lazyHomrBannerContent.set(data.homrBanner);
					}
					if ('homrInStoreServices' in data && this.inStoreServicesEnabled()) {
						this.lazyHomrInStoreServicesContent.set(data.homrInStoreServices);
					}
					if (
						this.enhancedContentEnabled() &&
						data.homrRichContent?.enhancedProductCard?.length
					) {
						this.homrWireSpot.set(true);
					}
				});
		}
	}

	ngAfterViewInit(): void {
		// When the app is loaded in the browser we want to move the Above the Fold content that is initially rendered
		// in the product container by detaching it and then inserting it into this component's template without destroying the instance.
		if (
			this.isPlatformBrowser() &&
			this.useAboveTheFoldMobileContainer() &&
			this.sourceAboveTheFoldViewRef()
		) {
			const view = this.sourceAboveTheFoldViewRef().detach();
			// We use this flag to determine if the Above the Fold content was completely moved and remove
			// the temporary styles used for adding a placeholder of the end position of the Above the Fold content
			this.wasAboveTheFoldContentLoaded.set(true);
			this.targetAboveTheFoldViewRef.insert(view);
			// Fire change detection for wasAboveTheFoldContentLoaded flag
			this.changeDetectorRef.detectChanges();
		}

		if (this.exclusiveType() && this.isPlatformBrowser()) {
			if (this.window.party) {
				this.setAuthenticatedAndExclusiveConnectedStatus(
					partyAttributes[this.exclusiveType()?.toLowerCase()]
				);
			} else {
				window.document.addEventListener('readyToParty', () => {
					this.setAuthenticatedAndExclusiveConnectedStatus(
						partyAttributes[this.exclusiveType()?.toLowerCase()]
					);
				});
			}
		}
	}

	/**
	 * @description Gets Identity ID from party attribues in session storage, if not available returns an empty string.
	 */
	private getIdentityIdFromStoredPartyAttr() {
		const attr = JSON.parse(sessionStorage.getItem(`partyAttributes`));
		if (attr) {
			return JSON.parse(attr?.partyAttributes)?.identityId;
		}
		return '';
	}

	private setAuthenticatedAndExclusiveConnectedStatus(exclusivePartyAttrName: string) {
		this.authService
			.getIsAuthenticated$()
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				catchError((error) => {
					this.logger.error(
						'Error getting authentication for exclusive product. ',
						error
					);
					this.isAuthenticated.set(false);
					return of(false);
				}),
				map(async (loggedIn) => {
					this.isAuthenticated.set(loggedIn);
					if (loggedIn) {
						// if user logged in, retrieve identity ID
						await this.authService
							.getIdentityId$()
							.then((identityId) => {
								// retrieve identity ID from session storage, and if they don't match, clear party attributes from session
								if (identityId !== this.getIdentityIdFromStoredPartyAttr()) {
									sessionStorage.removeItem(partyAttrText);
								}
							})
							.catch(() => {
								sessionStorage.removeItem(partyAttrText);
							})
							.finally(() => {
								this.exclusiveContentService
									.isUserConnectedToSpecificParty(exclusivePartyAttrName)
									.pipe(
										map((isConnected) => {
											this.isAuthenticatedAndExclusiveUnlocked.set(
												isConnected
											);
										})
									)
									.subscribe();
							});
					} else {
						// not logged in, remove party attributes from session
						sessionStorage.removeItem(partyAttrText);
						this.isAuthenticatedAndExclusiveUnlocked.set(false);
					}
				})
			)
			.subscribe();
	}

	openHighlyRatedFeatures() {
		this.highlyRatedFeaturesModal()?.openHighlyRatedFeatures();
	}

	private getRawExclusiveType(skus: ProductSku[]) {
		for (const sku of skus) {
			const apeAttribute = sku.descriptiveAttributes?.find(
				(attr) => attr.identifier === '5632'
			);
			for (const exclusiveType in exclusiveApeValue) {
				if (apeAttribute && apeAttribute.value === exclusiveApeValue[exclusiveType]) {
					return exclusiveType;
				}
			}
		}
	}

	login() {
		this.authService.login();
	}
}
